import React from 'react';
import { Link } from 'react-router-dom';
interface LogoProps {
  className?: string;
  onClick?: () => void;
}
export function Logo({
  className = '',
  onClick
}: LogoProps) {
  return <Link to="/" onClick={onClick} className={`inline-flex flex-col items-center justify-center group ${className}`} data-id="element-91">
      <div className="font-display leading-none text-center transition-transform group-hover:scale-105 duration-300" data-id="element-92">
        <div className="text-[#FF6B9D] text-4xl md:text-5xl tracking-normal" data-id="element-93">
          JANY
        </div>
        <div className="text-[#FF8A3D] text-3xl md:text-4xl tracking-normal -mt-2" data-id="element-94">
          & CO
        </div>
      </div>
      <div className="text-[0.4rem] md:text-[0.5rem] tracking-[0.3em] text-[#8A7B82] mt-2 font-semibold text-center uppercase" data-id="element-95">
        Talent & Influence Agency
      </div>
    </Link>;
}